import React from "react";

export const Li = ({ imc }) => {
  return <li>{imc}</li>;
};
